// extracted by mini-css-extract-plugin
module.exports = {"SCalendar":"DateItems_SCalendar__hgBJG","SEmptyItem":"DateItems_SEmptyItem__IuUbD"};